export default "__VITE_ASSET__CynYWUVT__"